var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('img',{attrs:{"src":"static/img/icon-checkmark.png"}}):_c('img',{attrs:{"src":"static/img/icon-x.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }